<template>
  <div
    :class="withIcon ? 'col-12 col-sm-4' : 'col-xs-12 col-sm-6 col-lg-3'"
  >
    <div class="form-group">
      <div class="custom-dropdown">
        <button
          class="form-control dropdown-toggle text-left investor"
          type="button"
          id="investor"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
            <slot></slot>
            Investor Type
            <i class="icon icon-arrow-down-custom icon-right"></i>
        </button>
        <div class="dropdown-menu" aria-labelledby="investor">
          <ul>
            <li v-for="providerType in providerTypesFiltered">
              <span class="custom-control custom-checkbox rtl">
                <input
                  type="checkbox"
                  name="investor[]"
                  class="custom-control-input"
                  :id="providerType.name"
                  :checked="selected(providerType)"
                  v-on:click="toggleSearch(providerType)"
                >
                  <label class="custom-control-label" :for="providerType.name">
                    {{ providerType.name }}
                    <sup class="text-primary lead help">
                      <!-- <strong
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Nulla non ipsum in enim condimentum viverra nec ac sem. Suspendisse convallis molestie nulla in consectetur. In porttitor risus id risus congue, nec accumsan urna pharetra.">
                          ?
                      </strong> -->
                    </sup>
                  </label>
                </input>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "investor-type-dropdown",
  props: ['withIcon', 'type'],
  computed: {
    ...mapGetters({
      results: "results",
      providerTypes: "providerTypes",
      capitalTypeSelected: 'capitalTypeSelected',
      providerTypeSelected: 'providerTypeSelected',
      countrySelected: 'countrySelected',
      sectorSelected: 'sectorSelected',
      dataProviderTypeSelected: 'dataProviderTypeSelected'
    }),
    providerTypesFiltered: function(){
      return this.providerTypes.filter(type=>!['Angel Investment', 'Private Equity'].includes(type.name))
    }
  },
  methods: {
    ...mapMutations([
      'toggleSectorsParam',
      'toggleCapitalTypesParam',
      'toggleProviderTypesParam',
      'toggleCountriesParam',
      'setSelectedDataProviderTypes'
    ]),
    selected: function(value){
      if (this.type=='chart') {
        return this.dataProviderTypeSelected(value)
      } else {
        return this.providerTypeSelected(value)
      }
    },
    ...mapActions(['search']),
    toggleSearch(value){
      if (this.type == 'chart') {
        this.setSelectedDataProviderTypes(value)
      } else {
        this.toggleProviderTypesParam(value)
      }
      this.$emit('user-select')
      $('.dropdown-menu').click(function(e) {
        e.stopPropagation();
      });
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/elements/SearchBars/dropdowns/InvestorTypeDropDown.vue